module.exports = __webpack_public_path__ + "img/1688694227925-IMG-20230707-WA0009.jpg.62f1cee1.webp";